export default "__VITE_ASSET__BjU5YD$2__"